export const environment = {
    production: false,
    controllApp: 'https://cedae.homologacao.vibetex.com.br/controlapp',
    mediaUrl: 'https://cedae.homologacao.vibetex.com.br',
    cedaeapp: 'https://cedae.homologacao.vibetex.com.br/cedae',
    apiBaseUrl: 'https://cedae.homologacao.vibetex.com.br',
    apiSuporte: 'http://localhost:8080',

};